//Libs
import { MouseEventHandler, useEffect, useState } from 'react';
import { FixedSizeList as List } from 'react-window';
//Types
import { IUser } from '../../Types/User/User.type';
//Style
import './Style/UsersGrid.css';
//Hooks
import { useGetAllUsers } from '../../Hooks/useGetAllUsers';
import { useModal } from '../../Hooks/useModal';
//Components
import User from './User';
import Loading from '../Common/Loading';
import Register from './Register';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { useFilter } from '../../Hooks/useFilterContext';


const UsersGrid = () => {
    const [users, setUsers] = useState<IUser[] | null>(null); 
    const [filteredUsers, setFilteredUsers] = useState<IUser[] | null>(null); 
    const {data, isLoading, error} = useGetAllUsers();
    const { filters, setFilters } = useFilter();

    const { openModal } = useModal();

    const handleRegisterModal: MouseEventHandler = () => {
        openModal(<Register/>)
    }
    useEffect(()=>{
        if(data){
            setUsers(data);
        }
    }, [data]);

    useEffect(()=> {
        if(!users) return;

        const lowerFilter = filters.search.toLowerCase();
        const filteredUsers = users?.filter(
            ({displayName, email, role}) =>
                (displayName!.toLowerCase().includes(lowerFilter) ||
                email!.toLowerCase().includes(lowerFilter) ||            
                role!.toLowerCase().includes(lowerFilter))            
        );
        setFilteredUsers(filteredUsers);
    }, [users, filters.search]);

    const renderUser = ({ index, style } : {index: number; style: React.CSSProperties}) => {
        if(!users) return null;
        const user = users[index];

        return (
            <div
                style={{
                    ...style,
                    marginBottom: '1rem'
                }}
                key={user.id}>
                <User user={user}/>
            </div>
        )
    }

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setFilters({ search: e.target.value });
        }

    return (
        <>
            {isLoading && <Loading loadingMessage='Carregando...'/>}
            {error && <p>{error}</p>}
            <header className='main-header'>
                <section className='header-text'>
                    <h2 className='header-title'>Usuarios</h2>
                    <p className='header-subtitle'>Gerencie seus usuarios</p>
                </section>
                <section className='header-controls'>
                    <button className='add-user-button' onClick={handleRegisterModal}>
                        <FontAwesomeIcon icon={faUserPlus} size='2x'/>
                        <p>Adicionar</p>
                    </button>
                </section>
                <section className='filters'>
                    <div className='filter-input'>
                        <FontAwesomeIcon icon={faSearch}/>
                        <input type="text" name="user-filter-input" id="user-filter-input" placeholder='Filtrar usuarios por nome, e-mail ou perfil' onChange={handleSearchChange}/>
                    </div>
                </section>
            </header>
            
            <ul className='users-grid'>
                <li className='header'>
                    <p className='user-name'>NOME</p>
                    <p className='user-email'>E-MAIL</p>
                    <p className='user-profile'>PERFIL</p>
                </li>
                {filteredUsers && (
                    <List 
                        className='list'
                        height={495}
                        itemCount={filteredUsers.length}
                        itemSize={80}
                        width="100%">
                        {renderUser}
                    </List>
                )}
            </ul>
        </>
    )
}

export default UsersGrid